import { Fragment, useState } from "react";
import BTDialogBox from "../BTDialgBox";
import BTTypography from "../BTTypography";
import { CircularProgress } from "@mui/material";
import { useNotification } from "../../context";
import { Notifications } from "@mui/icons-material";
import { manage_store_data } from "../../store/functions";
const ConfirmBox = ({
  row,
  setDelete,
  name,
  id,
  service,
  update,
  setRefresh,
}) => {
  const { addNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const handleDelete = async () => {
    try {
      setLoading(true);
      let response;
      if (name === "users") {
        response = await service({ attributes: { user_data: row } });
      } else {
        response = await service({ attributes: row });
      }
      if (response?.status === 1) {
        if (update && setRefresh) {
          const { stn_cts, stn_pcs } = response?.data;
          const record = update?.records?.find(
            (item) => item[id] === response?.data[update?.key]
          );
          setRefresh((prev) => !prev);
          manage_store_data({
            name: name,
            key: id,
            data: {
              ...record,
              sub_rows: Number(record?.sub_rows) - 1,
              sub_count: Number(record?.sub_count) - stn_pcs,
              sub_weight: Number(record?.sub_weight) - stn_cts,
            },
            type: "update",
          });
        }
        manage_store_data({
          name: name,
          key: id,
          data: response?.data,
          type: "remove",
        });
        addNotification({
          icon: <Notifications color="white" />,
          title: "Successfully",
          message: response?.message,
          color: "success",
        });
        setLoading(false);
        handleClose();
      }
    } catch (error) {
      setLoading(false);
      addNotification({
        icon: <Notifications color="white" />,
        title: "Error!",
        message: "Somthing Went Wrong!",
        color: "error",
      });
    }
  };
  const handleClose = () => {
    setDelete(null);
  };
  return (
    <BTDialogBox
      open={Boolean(row)}
      width="500px"
      maxWidth="md"
      minHeight={"50px"}
      close={handleClose}
      title="Delete confirmation"
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: handleClose,
        },
        {
          name: "Delete",
          variant: "gradient",
          color: "dark",
          size: "small",
          onClick: handleDelete,
          loading: loading,
          loadingComponent: (
            <Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient
                    id="my_gradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress
                size={22}
                sx={{
                  "svg circle": { stroke: "url(#my_gradient)" },
                }}
              />
            </Fragment>
          ),
          sx: { ml: 2, width: "80px" },
        },
      ]}>
      <BTTypography variant="body2" fontWeight={"light"}>
        Are you sure to delete this record ?
      </BTTypography>
    </BTDialogBox>
  );
};
export default ConfirmBox;
